<template>
  <div class="mb-5">
    <div class="mb-1 flex items-center">
      <div
        class="font-primary font-medium text-[13px] leading-[18px] text-gray-800 mr-2"
      >
        {{ label }}
      </div>

      <Tooltip v-if="isOwner" large @click="$emit('infoClick')">
        <TooltipTrigger
          class="pointer-events-none tablet-v:pointer-events-auto"
        >
          <Icon name="SquareInfo" :size="12" class="opacity-50" />
        </TooltipTrigger>
        <TooltipContent>
          <div class="w-[300px]">{{ tooltip }}</div>
        </TooltipContent>
      </Tooltip>
    </div>

    <div v-if="entities.length" class="mb-1.5 flex flex-col gap-y-1">
      <div
        v-for="entity in entities.slice(0, MAX_VISIBLE)"
        :key="entity.id"
        class="font-secondary leading-[18px] text-gray-800 flex items-center"
      >
        {{ entity.name }}
      </div>

      <div
        v-if="entities.length > MAX_VISIBLE"
        class="flex items-center font-medium text-gray-500 cursor-pointer gap-x-1.5"
        @click="$emit('moreClick')"
      >
        <div class="font-secondary">
          +{{ entities.length - MAX_VISIBLE }} more
        </div>
        <Icon name="ChevronUp" :size="14" class="rotate-180 stroke-gray-500" />
      </div>
    </div>

    <div v-else-if="showEmpty" class="font-secondary">- -</div>

    <div
      v-if="isOwner && addLabel"
      class="w-fit text-[14px] leading-[22px] font-medium font-secondary text-green-700 cursor-pointer"
      @click="$emit('addClick')"
    >
      {{ addLabel }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { Icon } from '@dacr/ui'
import { Tooltip, TooltipTrigger, TooltipContent } from '@dacr/ui/next'

const MAX_VISIBLE = 3

defineProps<{
  label: string
  entities: { id: string; name: string }[]
  isOwner: boolean
  tooltip: string
  addLabel?: string
  showEmpty?: boolean
}>()

defineEmits<{
  infoClick: []
  addClick: []
  moreClick: []
}>()
</script>
